import { faHome, faBook, faTh, faImagePortrait, faImage } from "@fortawesome/free-solid-svg-icons";
import { Routess } from "./routes";

export const sidebarMenu = [
    {
      title: "Books Category",
      icon: faTh,
      link: Routess.BooksCategory.path,
      permission: Routess.BooksCategory.permission,
    },
    {
      title: "Books",
      icon: faBook,
      link: Routess.Books.path,
      permission: Routess.Books.permission,
    },
    {
      title: "Thoughts",
      icon: faImage,
      link: Routess.Thoughts.path,
      permission: Routess.Thoughts.permission,
    },
    // {
    //   title: "Website",
    //   icon: faGlobe,
    //   eventKey: "websites/",
    //   permission: "CANMANAGEWEBSITE",
    //   children: [
    //     { title: "Banners", link: Routess.Banners.path, permission: Routess.Banners.permission },
    //     { title: "News & Events", link: Routess.NewsAndEvent.path, permission: Routess.NewsAndEvent.permission },
    //     { title: "Staff", link: Routess.Staff.path, permission: Routess.Staff.permission },
    //     { title: "Admission Enquiry", link: Routess.Enquiry.path, permission: Routess.Enquiry.permission },
    //     { title: "Contact Enquiry", link: Routess.ContactEnquiry.path, permission: Routess.ContactEnquiry.permission },
    //     { title: "Gallery", link: Routess.Gallery.path, permission: Routess.Gallery.permission },
    //     { title: "Social Accounts", link: Routess.SocialAccounts.path, permission: Routess.SocialAccounts.permission },
    //   ],
    // },
  ];
  